import { IMunicipality } from '../../../../../models/municipality.model';
import { t } from '../../../../../services/texts.service';
import Fact from '../../../../Shared/Fact';
import { IconMotif } from '../../../../Shared/Icon/icon-motif.enum';

export default function MunicipalitiesFact({ municipalities, className = '' }: { municipalities: IMunicipality[]; className?: string }): React.ReactNode | null {
  if (municipalities.length === 0) return null;

  const municipalityLabel = municipalities.length === 1 ? t('Kommun', 'Municipality') : t('Kommuner', 'Municipalities');

  return (
    <Fact className={className} iconMotif={IconMotif.Municipality} altText="">
      <div>
        <span className="fw-bold">{municipalityLabel}:</span> {municipalities.map((m) => m.name).join(', ')}
      </div>
    </Fact>
  );
}
